import GraphicStandActionField from './graphic-stand-action-field';
import GraphicStandTitleField from './graphic-stand-title-field';
import GraphicStandPackedUserField from './graphic-stand-packed-user-field';
import GraphicStandStatusField from './graphic-stand-status-field';
import GraphicStandMaterialsField from './graphic-stand-materials-field';
import GraphicStandGraphicField from './graphic-stand-graphic-field';
import GraphicStandNewLocationField from './graphic-stand-new-location-field';
import GraphicStandCreateButton from './graphic-stand-create-button';
import GraphicStandCommentField from './graphic-stand-comment-field';
import GraphicStandReturnWarehouseField from './graphic-stand-return-warehouse-field';
import GraphicStandWarehouseActionField from './graphic-stand-warehouse-action-field';
import GraphicStandShelfField from './graphic-stand-shelf-field';

const GraphicStandFields = {
    Action: GraphicStandActionField,
    Status: GraphicStandStatusField,
    Title: GraphicStandTitleField,
    PackedUser: GraphicStandPackedUserField,
    Materials: GraphicStandMaterialsField,
    Graphic: GraphicStandGraphicField,
    NewLocation: GraphicStandNewLocationField,
    CreateButton: GraphicStandCreateButton,
    Comment: GraphicStandCommentField,
    ReturnWarehouse: GraphicStandReturnWarehouseField,
    WarehouseAction: GraphicStandWarehouseActionField,
    Shelf: GraphicStandShelfField,
};

export default GraphicStandFields;